<template>
  <div class="">

    <dropper :index="index" :level="2"></dropper>
    <div  v-if="$parent.editMode"  class="delete is-pulled-right" @click="remove"></div>

    <div class="cmsFooter bledHeroBlack bleed">
        <div class="has-text-white container ">
            <img class="top12" src="@/assets/img/Miimu logo.png" width="165" />
           <div class="is-size-3">
                EXPLORE,
                BUNDLE & SHARE
           </div>
            <div>Capture, organize and share the online content you care about, all in one place.</div>
            <button class="button is-coolGreen top30" @click="$router.push('/')">GET STARTED</button>

        </div>
    </div>
       
  </div>
</template>

<script>

import dropper from './sectionDropper.vue'
import { AZEventBus } from '../AZEventBus'

export default {
    props: {params: Object, index: Number},
    components: {dropper},
    data: function(){
        return {
       
        }
    },

    methods: {
      
        remove: function(){
            this.$parent.removeSection(this.index)
        },

    
    }
}

</script>